<template>
  <help-dialog title="AI Assistant (BETA)">
    <template #default>
      <div class="chat-log-help">
        <h3 class="mb-1 heading">
          <span class="title-highlight">Chat with your Workflow Assistant</span>
        </h3>
        <p class="body">
          Keep track of every step in your workflow journey. Ask questions, get instant AI‑powered suggestions, and see
          real‑time updates right here in this chat. All of your prompts, AI responses, and automated function‑calls
          are saved chronologically, so you can review decisions, audit changes, and pick up right where you left off.
          Whether you’re brainstorming improvements, creating events, or restructuring lanes, our assistant is here to
          guide you every step of the way.
        </p>
        <br />
        <p class="body">
          <b>Note:</b> This feature is currently in beta. We’re actively adding new actions and
          capabilities. Check back soon for even more automation options!
        </p>
        <br />
        <h4 class="mb-1 heading">Available actions</h4>
        <ul class="ml-5">
          <li v-for="action in availableActions" :key="action">
            <b>{{ action }}</b>
          </li>
        </ul>
        <br />
        <h4 class="mb-1 heading">Bulk AI actions</h4>
        <ul class="ml-5">
          <li v-for="action in bulkActions" :key="action">
            <b>{{ action }}</b>
          </li>
        </ul>
      </div>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'

const availableActions = [
  'Create / update / delete event',
  'Update workflow name',
  'Create / update / delete / move lane',
  'Create / update / delete / vote card',
  'Create / update / delete entity',
  'Create / update command',
  'Create / update read model'
]

const bulkActions = [
  'Plan workflow with AI',
  'Generate cards / commands / entities / read models from description',
  'Add missing cards / entities / commands / read models',
  'Regenerate cards / entities / commands / read models',
  'Analyze domain model',
  'Validate domain model',
  'Rollback workflow'
]

</script>

<style scoped>
.chat-log-help .heading {
  color: #000000;
}

.chat-log-help .body {
  color: #424242;
}

.chat-log-help .title-highlight {
  background-color: #EEEEEE;
}

[data-theme="dark"] .chat-log-help .heading {
  color: var(--text-dark);
}

[data-theme="dark"] .chat-log-help .body {
  color: var(--text-dark);
}

[data-theme="dark"] .chat-log-help .title-highlight {
  background-color: var(--light-3);
}
</style>
